import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ErrorPage from './ErrorPage';
import ErrorActions from '../../store/errorRedux'

/** Dual-function Error boundary that listens for component rendering errors,
 *  as well as any errors put into the Redux store by another component. 
 *  Currently: these errors are added primarily from the serviceUtil on http error. 
 *  Future: can be modified to better handle multiple error states. */
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorDetail: null };
    }

    componentDidMount() {
        // clear errors when a user tries to navigate elsewhere
        this.props.history.listen(() => this.props.clearErrors())
    }

    componentDidCatch(error, errorDetail) {
        // todo: possible NewRelic logging? (or would this even be necessary?)
        this.setState({
            error: error,
            errorDetail: errorDetail
        })
    }

    render() {
        // return any errors automatically caught by the error boundary
        if (this.state.error) {
            return <ErrorPage
                error={this.state.error}
                errorDetail={this.state.errorDetail} />
        }

        // return any non-component errors thrown from elsewhere in the app
        if (this.props.nonComponentError.error) {
            return <ErrorPage
                error={this.props.nonComponentError.error}
                errorDetail={this.props.nonComponentError.errorDetail} />
        }

        // Parents are acting responsibly, return their children to them
        return this.props.children;
    }
}

const mapStateToProps = (state) => ({
    nonComponentError: state.error
})

const mapDispatchToProps = (dispatch) => ({
    clearErrors: () => dispatch(ErrorActions.resetErrors())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary))